// removed by extract-text-webpack-plugin
module.exports = {"title":"_2uhRexqiN7O6cVB0FgqCOU_0","exit":"xlvJONYEidzPyj_1Bb5CV_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f3e08d06","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Alert/AlertWithText.vue
// module id = jwcO
// module chunks = 4